//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import api from "@/services/api";
import { server, imageUrl } from "@/services/constants";
import StockCard from "@/components/cards/StockCard";
import SuccessDialog from "@/components/cards/SuccessDialog";
import { Loader } from "@googlemaps/js-api-loader";
import unity from "@/unity/unity";
export default {
  name: "Dashboard",
  data() {
    return {
      sec_acc_my_time_off: false,
      sec_acc_approve_time_off: false,
      sec_acc_time_attendance: false,
      sec_acc_out_of_office: false,
      sec_acc_list: [],

      leave_list: [],
      leave_number: "0",
      dialogAdd: false,
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      th_name: "",
      eng_name: "",
      worker_time: "",
      sick_day: 0,
      sick_hours: 0.0,
      vacation_day: 0,
      pending_cont: 0,
      vacation_hours: 0.0,
      leavehistory_list: [],
      leaveApprove_list: [],
      datenow_show: null,
      timenow_show: null,
      expecttime: null,
      statusActivity: "",
      checkindate: null,
      dialogcCheckIn: false,
      currentTime: "",
      dataActivivty: {},
      duration: 0,
      update_id: 0,
      location_lat: null,
      location_lng: null,
      wasDenied: false,
    };
  },
  components: {
    StockCard,
    SuccessDialog,
  },
  async mounted() {
    try {
      await api.checkVersion();

      const userId = localStorage.getItem(server.USER_ID);
      if (!userId || !api.isLoggedIn()) {
        this.$store.state.isLogged = false;
        this.$router.push("/login");
        return;
      }

      localStorage.setItem(server.MODELMENU, 0);

      // โหลดข้อมูลทั้งหมด
      await Promise.all([
        this.getSectionData(),
        this.loadActivityData(),
        this.loadEmpdata(),
        this.loadQuota(),
        this.loadleaveHistory(),
        this.loadleaveApprove(),
        this.loadLeave(),
      ]);

      this.$hideLoader();

      // ตั้ง interval
      setInterval(this.updateTime, 1000);
      setInterval(this.initMap, 300000);

      // เช็ค geolocation permission
      if (navigator.permissions) {
        const permissionStatus = await navigator.permissions.query({
          name: "geolocation",
        });

        if (permissionStatus.state === "denied") {
          this.wasDenied = true;
        }

        permissionStatus.onchange = () => {
          if (this.wasDenied && permissionStatus.state === "granted") {
            location.reload();
          }
        };
      }
    } catch (error) {
      console.error("Error in mounted:", error);
      this.$hideLoader();
    }
  },
  methods: {
    async getSectionData2() {
      const result = await api.getSectionAccessConfig_By_CompanyID(
        localStorage.getItem(server.COMPANYID),
      );
      // console.log(`Section Access Data: ${JSON.stringify(result.data)}`);

      let my_positions_id = parseInt(localStorage.getItem(server.POSITION_ID));
      // console.log(`Section Access my_positions_id: ${my_positions_id}`);

      // ตั้งค่าเริ่มต้นทุก section เป็น false
      this.sec_acc_approve_time_off = false;
      this.sec_acc_my_time_off = false;
      this.sec_acc_time_attendance = false;
      this.sec_acc_out_of_office = false;

      // เช็คแต่ละ section ว่า position_id ของ user อยู่ใน position_id array หรือไม่
      for (const section of result.data) {
        const hasAccess = section.position_id.includes(my_positions_id);

        switch (section.section_id) {
          case "SEC-001":
            this.sec_acc_approve_time_off = hasAccess;
            break;
          case "SEC-002":
            this.sec_acc_my_time_off = hasAccess;
            break;
          case "SEC-003":
            this.sec_acc_time_attendance = hasAccess;
            break;
          case "SEC-004":
            this.sec_acc_out_of_office = hasAccess;
            break;
          default:
            console.warn(
              `Unknown section_id: ${section.section_id} in section access data.`,
            );
        }
      }

      this.sec_acc_list = result.data;
      this.$hideLoader();
    },

    async getSectionData() {
      const result = await api.getSectionAccessConfig_By_CompanyID(
        localStorage.getItem(server.COMPANYID),
      );

      let my_positions_id = parseInt(localStorage.getItem(server.POSITION_ID));

      // ตั้งค่าเริ่มต้น
      this.sec_acc_approve_time_off = false;
      this.sec_acc_my_time_off = false;
      this.sec_acc_time_attendance = false;
      this.sec_acc_out_of_office = false;

      // ✅ เช็คว่า result.data มีข้อมูลก่อน
      if (!result.data || result.data.length === 0) {
        console.warn("No section access data found");
        this.$hideLoader();
        return;
      }

      for (const section of result.data) {
        // ✅ เช็คว่า section_id มีค่า
        if (!section.section_id) {
          console.warn("Section without section_id:", section);
          continue;
        }

        // ✅ เช็คว่า position_id เป็น array
        if (!Array.isArray(section.position_id)) {
          console.warn("Invalid position_id format:", section);
          continue;
        }

        const hasAccess = section.position_id.includes(
          my_positions_id.toString(),
        );

        switch (section.section_id) {
          case "SEC-001":
            this.sec_acc_approve_time_off = hasAccess;
            break;
          case "SEC-002":
            this.sec_acc_my_time_off = hasAccess;
            break;
          case "SEC-003":
            this.sec_acc_time_attendance = hasAccess;
            break;
          case "SEC-004":
            this.sec_acc_out_of_office = hasAccess;
            break;
          default:
            console.warn(`Unknown section_id: ${section.section_id}`);
        }
      }

      this.sec_acc_list = result.data;
      this.$hideLoader();
    },

    initMap() {
      const loader = new Loader({
        apiKey: "AIzaSyBi65wGqm0gq3E3gKUK7DQp99rIKiVYEmc",
        version: "weekly",
        libraries: ["places"],
      });

      loader.load().then(() => {
        // ✅ เช็คว่า element มีอยู่จริงก่อน
        const mapElement = document.getElementById("map");
        if (!mapElement) {
          console.warn("Map element not found");
          return;
        }

        let defaultLatLng = { lat: 13.7563, lng: 100.5018 };

        if (this.location_lat !== null && this.location_lng !== null) {
          defaultLatLng = {
            lat: this.location_lat,
            lng: this.location_lng,
          };
        }

        this.map = new google.maps.Map(mapElement, {
          center: defaultLatLng,
          zoom: 13,
        });

        // ถ้ายังไม่มี location เก่าเลย ให้ดึงใหม่
        if (
          this.location_lat === null &&
          this.location_lng === null &&
          navigator.geolocation
        ) {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              const lat = parseFloat(position.coords.latitude.toFixed(4));
              const lng = parseFloat(position.coords.longitude.toFixed(4));

              this.location_lat = lat;
              this.location_lng = lng;

              const userLatLng = { lat, lng };

              this.map.setCenter(userLatLng);

              new google.maps.Marker({
                position: userLatLng,
                map: this.map,
                title: "You are here",
                icon: {
                  url: "http://maps.google.com/mapfiles/ms/icons/blue-dot.png",
                },
              });
            },
            () => {
              console.warn("ไม่สามารถระบุตำแหน่งได้");
            },
          );
        } else {
          // มีค่าพิกัดแล้ว → เพิ่ม marker ด้วยค่าเก่า
          new google.maps.Marker({
            position: {
              lat: this.location_lat,
              lng: this.location_lng,
            },
            map: this.map,
            title: "Last known location",
            icon: {
              url: "http://maps.google.com/mapfiles/ms/icons/blue-dot.png",
            },
          });
        }
      });
    },
    updateTime() {
      ///โหดล เเบบเรียวทาม
      const now = new Date();

      // แปลงเวลาตาม 12-hour format (AM/PM)
      const hours = now.getHours();
      const minutes = String(now.getMinutes()).padStart(2, "0");
      const period = hours >= 12 ? "PM" : "AM"; // AM/PM
      const formattedHours = hours % 12 === 0 ? 12 : hours % 12;

      // convert 0 to 12 for 12-hour format
      this.currentTime = `${formattedHours}:${minutes} ${period}`;

      if (this.statusActivity == "checkin") {
        this.loadDataChecKIN();
      } else if (this.statusActivity == "checkout") {
        if (this.dataActivivty) {
          this.loadDataChecKOut(this.dataActivivty);
        }
      } else {
        return;
      }
    },
    async loadLeave() {
      var data_leave_set = {
        date_now: new Date().toISOString().split("T")[0],
        company_id: Number(localStorage.getItem(server.COMPANYID)),
      };
      const res_leave = await api.getToDashboard({ params: data_leave_set });
      var dataleave = Object.values(
        res_leave.data.reduce((acc, item) => {
          // สร้าง key โดยไม่เอา amount
          const key = `${item.userid}-${item.strc_date}`;

          if (!acc[key]) {
            acc[key] = { ...item };
          } else {
            acc[key].amount = Number(item.amount) + Number(acc[key].amount);
          }

          return acc;
        }, {})
      );
      this.leave_list = dataleave;
      this.leave_number = dataleave.length;

      for (const [index, item] of this.leave_list.entries()) {
        if (item.image_profile != "" && item.image_profile != null) {
          item.image_profile = imageUrl + "/" + item.image_profile;
        } else {
          item.image_profile = "";
        }

        var leave_day = 0;
        var leave_hours = 0;

        leave_day = Math.floor(Number(item.amount) / 60 / 8);
        leave_hours = Number(Number(item.amount) / 60) - leave_day * 8;

        if (leave_day == 0) {
          if (leave_hours == 0) {
            item.description = ``;
          } else if (leave_hours == 4) {
            item.description = item.description = `Half Day`;
          } else if (leave_hours == 8) {
            item.description = item.description = `Full Day`;
          } else {
            item.description = item.description = `${leave_hours} Hours`;
          }
        } else {
          if (leave_hours == 0) {
            if (leave_day > 1) {
              item.description = `${leave_day} Day`;
            } else {
              item.description = `Full Day`;
            }
          } else {
            item.description = item.description = `${leave_day} Day ${leave_hours} Hours`;
          }
        }
      }
      // this.leave_list = []
    },
    async loadActivityData() {
      const resCheckInData = await api.getCheckinDateWeb(
        localStorage.getItem(server.USER_ID),
      );
      if (resCheckInData.data.length > 0) {
        this.statusActivity = "checkout";

        this.location_lng = resCheckInData.data[0].location_lng;
        this.location_lat = resCheckInData.data[0].location_lat;

        this.update_id = resCheckInData.data[0].id;
        this.dataActivivty = resCheckInData.data[0];

        var checkinDate = new Date(resCheckInData.data[0].checkInDate_Date);
        //เซต เวลา checkin
        const formattedStartTime = checkinDate.toLocaleTimeString("en-US", {
          hour: "numeric",
          minute: "2-digit",
          hour12: true,
        });
        this.checkindate = `${formattedStartTime}`;

        // เพิ่มเวลา 9 ชั่วโมง
        const expectTime = new Date(checkinDate.getTime() + 9 * 60 * 60 * 1000); // เพิ่ม 9 ชั่วโมง (9 * 60 * 60 * 1000 ms)
        const formattedExpectDate = expectTime.toLocaleDateString("en-US", {
          month: "short",
          day: "numeric",
        });
        const formattedExpectTime = expectTime.toLocaleTimeString("en-US", {
          hour: "numeric",
          minute: "2-digit",
          hour12: true,
        });

        // สร้างค่า expecttime
        this.expecttime = `${formattedExpectTime}`;

        this.loadDataChecKOut(this.dataActivivty);
      } else {
        this.location_lng = null;
        this.location_lat = null;
        this.statusActivity = "checkin";
        this.dataActivivty = {};
        this.loadDataChecKIN();
      }
      this.initMap();
    },
    loadDataChecKIN() {
      const now = new Date();

      //checkin datetime
      const formattedStartDate = now.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
      });
      const formattedStartTime = now.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      });
      this.checkindate = `${formattedStartDate}, ${formattedStartTime}`;

      // เพิ่มเวลา 9 ชั่วโมง
      const expectTime = new Date(now.getTime() + 9 * 60 * 60 * 1000); // เพิ่ม 9 ชั่วโมง (9 * 60 * 60 * 1000 ms)
      const formattedExpectDate = expectTime.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
      });
      const formattedExpectTime = expectTime.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      });

      // สร้างค่า expecttime
      this.expecttime = `${formattedExpectTime}`;

      //date show
      const options = {
        year: "numeric",
        month: "short",
        day: "numeric",
        weekday: "short",
      };

      // ใช้ Intl.DateTimeFormat เพื่อให้แน่ใจว่าการแสดงผลถูกต้อง
      const formatter = new Intl.DateTimeFormat("en-US", options);
      const parts = formatter.formatToParts(now);

      // ดึงค่าจาก parts เพื่อเรียงข้อมูลใหม่
      let weekday = "";
      let month = "";
      let day = "";
      let year = "";

      parts.forEach(({ type, value }) => {
        if (type === "weekday") weekday = value;
        if (type === "month") month = value;
        if (type === "day") day = value;
        if (type === "year") year = value;
      });

      const finalFormattedDate = `${month} ${day}, ${year} (${weekday})`;
      this.datenow_show = finalFormattedDate;
    },
    loadDataChecKOut(data) {
      // this.checkindate
      // console.log(data)

      //เซต datetime show
      const now = new Date();

      //date show
      const options = {
        year: "numeric",
        month: "short",
        day: "numeric",
        weekday: "short",
      };

      // ใช้ Intl.DateTimeFormat เพื่อให้แน่ใจว่าการแสดงผลถูกต้อง
      const formatter = new Intl.DateTimeFormat("en-US", options);
      const parts = formatter.formatToParts(now);

      // ดึงค่าจาก parts เพื่อเรียงข้อมูลใหม่
      let weekday = "";
      let month = "";
      let day = "";
      let year = "";

      parts.forEach(({ type, value }) => {
        if (type === "weekday") weekday = value;
        if (type === "month") month = value;
        if (type === "day") day = value;
        if (type === "year") year = value;
      });

      const finalFormattedDate = `${month} ${day}, ${year} (${weekday})`;
      this.datenow_show = finalFormattedDate;

      //คำนวณเวลา
      var checkinDate = new Date(data.checkInDate_Date);
      var checkoutDate = now;

      // console.log("checkinDate: " + checkinDate)
      // console.log("checkoutDate: " + checkoutDate)

      // คำนวณความแตกต่างระหว่างเวลาทั้งสอง (ในมิลลิวินาที)
      var timeDifference = checkoutDate - checkinDate;

      // แปลงมิลลิวินาทีเป็นนาที
      var timeDifferenceInMinutes = timeDifference / (1000 * 60);

      // ตรวจสอบและลดเวลาตามเงื่อนไข
      if (timeDifferenceInMinutes >= 300) {
        timeDifferenceInMinutes -= 60; // ลด 60 นาที หากเวลามากกว่า 300 นาที
      }

      // ตรวจสอบให้เวลามากสุดไม่เกิน 480 นาที
      if (timeDifferenceInMinutes > 480) {
        timeDifferenceInMinutes = 480; // จำกัดเวลาที่ 480 นาที
      }
      this.duration = Math.floor(timeDifferenceInMinutes);
      const hours = Math.floor(timeDifferenceInMinutes / 60); // คำนวณชั่วโมง
      const minutes = Math.floor(timeDifferenceInMinutes % 60);

      const formattedTimeDifference = `${hours}h ${minutes}m`;
      this.worker_time = formattedTimeDifference;
    },
    async loadEmpdata() {
      const res_emp = await api.getAccountByidMenu(
        localStorage.getItem(server.USER_ID),
      );

      this.th_name = res_emp.data[0].name;
      this.eng_name = res_emp.data[0].eng_name;
    },
    async loadQuota() {
      const res_quota = await api.getListByUserDashboard(
        localStorage.getItem(server.USER_ID),
      );
      if (res_quota.data && res_quota.data.length > 0) {
        var canuse_leave = 0;
        canuse_leave = Number(res_quota.data[0].leave_can_use);
        this.vacation_day = Math.floor(canuse_leave);
        this.vacation_hours = (canuse_leave - this.vacation_day) * 8;
      } else {
        this.vacation_day = 0;
        this.vacation_hours = 0;
      }
    },
    async loadleaveHistory() {
      const res_leave_history = await api.getListHistoryAll(
        localStorage.getItem(server.USER_ID),
      );
      if (res_leave_history.data && res_leave_history.data.length > 0) {
        const filteredData = res_leave_history.data.filter(
          (item) => item.status === 1,
        );
        this.pending_cont = filteredData.length;
      } else {
        this.pending_cont = 0;
      }
    },
    async loadleaveApprove() {
      const res_leave_approve = await api.getListApprove(
        localStorage.getItem(server.USER_ID),
      );

      for (const [index, item] of res_leave_approve.data.entries()) {
        if (item.leave_type == "Sick Leave") {
          item.leave_type = "Sick";
        } else if (item.leave_type == "Vacation Leave") {
          item.leave_type = "Vacation";
        }
        var leave_day = 0;
        var leave_hours = 0;

        leave_day = Math.floor(Number(item.hours_amount) / 8);
        leave_hours = Number(item.hours_amount) - leave_day * 8;

        if (leave_day == 0) {
          if (leave_hours == 0) {
            item.description = `${item.data_date}`;
          } else {
            item.description = item.description = `${item.data_date} (${leave_hours} hours)`;
          }
        } else {
          if (leave_hours == 0) {
            item.description = `${item.data_date} (${leave_day} day)`;
          } else {
            item.description = item.description = `${item.data_date} (${leave_day} day ${leave_hours} hours)`;
          }
        }
        if (item.image != "" && item.image != null) {
          item.image_profile = imageUrl + "/" + item.image;
        } else {
          item.image_profile = "";
        }
      }
      this.leaveApprove_list = res_leave_approve.data;
    },
    async goToLeaveHistory() {
      this.$router.push("/my-time-off");
    },
    async goToLeaveHistoryById(id, status) {
      if (status == 1) {
        this.$router.push(`/leave-request-edit/${id}`);
      } else {
        this.$router.push(`/leave-request-waiting/${id}/dashboard`);
      }
    },
    async goToLeaveApprove() {
      // เปลี่ยน URL หรือทำการนำทางที่ต้องการ
      this.$router.push("/approver-time-off"); // หากคุณใช้ Vue Router
      // หรือ window.location.href = 'URL ที่ต้องการ'; // หากคุณต้องการเปลี่ยนไปยัง URL อื่น
    },
    async goToLeaveApproveById(id, user_id) {
      // เปลี่ยน URL หรือทำการนำทางที่ต้องการ
      this.$router.push(`/approve-leave-confirm/${id}/${user_id}`); // หากคุณใช้ Vue Router
      // หรือ window.location.href = 'URL ที่ต้องการ'; // หากคุณต้องการเปลี่ยนไปยัง URL อื่น
    },
    CheckInOut() {
      this.dialogcCheckIn = true;
    },
    closecheckInOu() {
      this.dialogcCheckIn = false;
    },
    async checkInOutConfirm() {
      this.dialogcCheckIn = false;

      // สร้างรูปแบบวันที่ตามที่ต้องการ
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0"); // เดือนเริ่มจาก 0, ดังนั้นต้อง +1
      const day = String(now.getDate()).padStart(2, "0");
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");

      // สร้างวันที่ในรูปแบบ yyyy:mm:dd HH:MM:00
      const formattedDate = `${year}:${month}:${day} ${hours}:${minutes}:00`;

      if (this.statusActivity == "checkout") {
        var dataUpdate = {};

        dataUpdate.chargeType = "";
        dataUpdate.checkOutDate = formattedDate;
        dataUpdate.isCheckedOut = 1;
        dataUpdate.jobTitleId = 0;
        dataUpdate.customerId = 0;
        dataUpdate.prospect = "";
        dataUpdate.detail = "";
        dataUpdate.duration = this.duration;
        dataUpdate.addby = "W";
        this.$showLoader();
        const res_updateAct = await api.updateActivity(
          this.update_id,
          dataUpdate,
        );

        if (res_updateAct.status == 200 || res_updateAct.status == 201) {
          this.datenow_show = null;
          this.timenow_show = null;
          this.expecttime = null;
          this.checkindate = null;
          await this.loadActivityData();
          await this.loadEmpdata();
          await this.loadQuota();
          await this.loadleaveHistory();
          await this.loadleaveApprove();
          this.$hideLoader();

          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Information Saved",
            "Information successfully saved",
            "text-h5 green--text text-center",
          );
          return;
        } else {
          this.$hideLoader();
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Information Saved",
            "ไม่สามารถบันทึกได้",
            "text-h5 red--text text-center",
          );
          return;
        }
      } else {
        if (navigator.permissions) {
          const permissionStatus = await navigator.permissions.query({
            name: "geolocation",
          });
          if (permissionStatus.state === "denied") {
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "Information Saved",
              "To use this feature, please allow location access in your browser settings.",
              "text-h5 red--text text-center",
            );
            return; //หยุดทำงานต่อ
          }
        }

        var addItem = {};
        addItem.location_lat = this.location_lat;
        addItem.location_lng = this.location_lng;
        addItem.chargeType = "";
        addItem.company_id = Number(localStorage.getItem(server.COMPANYID));
        addItem.checkInDate = formattedDate;
        addItem.isCheckedOut = 0;
        // addItem.checkOutDate = `${this.dataItem.checkout} ${this.dataItem.timecheckout}`;
        // addItem.isCheckedOut = 1;
        addItem.userId = Number(localStorage.getItem(server.USER_ID));
        addItem.departmentId = Number(
          localStorage.getItem(server.DEPARTMENT_ID),
        );
        addItem.jobTitleId = 0;
        addItem.customerId = 0;
        addItem.prospect = "";
        addItem.detail = "";
        addItem.addby = "W";
        addItem.check_auto = 0;
        addItem.status = "A";

        this.$showLoader();
        const res_addAct = await api.createActivityCheckin(addItem);
        if (res_addAct.status == 200 || res_addAct.status == 201) {
          this.datenow_show = null;
          this.timenow_show = null;
          this.expecttime = null;
          this.checkindate = null;
          await this.loadActivityData();
          await this.loadEmpdata();
          await this.loadQuota();
          await this.loadleaveHistory();
          await this.loadleaveApprove();
          this.$hideLoader();

          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Information Saved",
            "Information successfully saved",
            "text-h5 green--text text-center",
          );
          return;
        } else {
          this.$hideLoader();
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Information Saved",
            "ไม่สามารถบันทึกได้",
            "text-h5 red--text text-center",
          );
          return;
        }
      }
    },
    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
  },
  beforeCreate() {
    this.$store.state.navMenu = true;
  },
};
